export enum TaskStatus {
  OPEN = 0,
  CLOSED_USER = 1,
  CLOSED_ORG = 2
}

export enum TaskProgress {
  INVITE = 'progress_invite',
  REMIND = 'progress_remind',
  BOUNCE = 'progress_bounce',
  BUSY = 'progress_busy',
  DONE = 'progress_done'
}

interface Task {
  th: string;
  datestart?: string;
  status?: TaskStatus;
  field?: {
    frm_date_end: string;
    frm_invite_mes: string;
    progress: TaskProgress;
  };
  frm_label: string;
  link: string;
}
export default Task
